import { Card, CardProps, Flex, Typography } from 'antd';

const { Text, Title } = Typography;

interface WidgetTitleProps {
  children: React.ReactNode;
  type: 'thin' | 'bold' | 'normal';
  variant?: 'success' | 'error' | 'warning' | 'info' | 'default';
  className?: string;
  style?: React.CSSProperties;
}

export const WidgetTitle = ({
  children,
  type,
  variant = 'default',
  ...props
}: WidgetTitleProps) => {
  const classes = {
    thin: 'widget-title--thin',
    bold: 'widget-title--bold',
    normal: 'widget-title--normal',
    success: 'widget-title--success',
    error: 'widget-title--error',
    warning: 'widget-title--warning',
    info: 'widget-title--info',
    default: '',
  };
  const className = `widget-title m-0 ${classes?.[type]} ${classes?.[variant]}  ${props.className || ''}`;

  if (type === 'bold') {
    return (
      <Title ellipsis level={2} className={className} style={props.style}>
        {children}
      </Title>
    );
  }
  return (
    <Text ellipsis className={className} style={props.style}>
      {children}
    </Text>
  );
};

const WidgetCard = ({ children, className, ...props }: CardProps) => {
  const classes = `widget-card ${className || ''}`;
  return (
    <Card className={classes} {...props}>
      <Flex vertical className="h-100" justify="center" gap={8}>
        {children}
      </Flex>
    </Card>
  );
};

export interface ActivityWidgetProps {
  isLoading: boolean;
}

export default WidgetCard;
